import NewsTipCommentSection from './NewsTipCommentSection'

export default NewsTipCommentSection
